import React from 'react'

function Footer() {
  return (
    <section id="contactus">
      <div className="container-fluid padding">
        <div className="row text-center padding footer">
          <div className="col-12 mt-5">
            <h1 className="text-center">CONTACT US</h1>
            <hr className="light" />
            <p>Contact : (+91) 9618493067</p>
            <p>Email to : aryavartastaffingsolutions@gmail.com</p>
            <p>Address : </p>
            <p>1-502/1 Talatampara Main Street</p>
            <p>Kanchili Srikakulam </p>
            <p>AP 532292</p>
          </div>
          <div className="col-12">
            <hr className="light" />
            <h5 className="text-center">&copy;aryavartstaffingsolutions.com</h5>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Footer
